document.addEventListener('DOMContentLoaded', function () {

  const btn = document.querySelector('.size-chart-btn');
  const modal = document.getElementById('SizeChartModal');
  const closeBtn = document.querySelector('.size-chart-close');
  const overlay = document.querySelector('.size-chart-overlay');

  if(btn){
    btn.addEventListener('click', function(){
      modal.style.display = 'block';
    });
  }

  if(closeBtn){
    closeBtn.addEventListener('click', function(){
      modal.style.display = 'none';
    });
  }

  if(overlay){
    overlay.addEventListener('click', function(){
      modal.style.display = 'none';
    });
  }

});